
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Improved SSR hydration support
const rootElement = document.getElementById("root");

// Function to ensure Neeto chat widget is initialized
const ensureNeetoChatInitialized = () => {
  if (window.embedNeetoWidget && typeof window.embedNeetoWidget === 'function') {
    try {
      // Check if we've already initialized to avoid duplicates
      if (!window.neetoChatInitialized) {
        window.embedNeetoWidget({
          apiKey: "J1cGcsLTDkc5iNsZ",
        });
        window.neetoChatInitialized = true;
        console.log("Neeto chat initialized from main.tsx");
      }
    } catch (e) {
      console.error("Failed to initialize Neeto chat:", e);
    }
  } else {
    console.log("Neeto widget not available yet");
  }
};

// Initialize chat after React app is mounted
const initializeAfterMount = () => {
  // Short timeout to let the React app stabilize
  setTimeout(() => {
    ensureNeetoChatInitialized();
  }, 1000);
};

if (rootElement) {
  // Check if the root has server-rendered content by checking for child nodes
  if (rootElement.hasChildNodes()) {
    // Proper hydration for SSR content
    console.log("Hydrating existing server-rendered content");
    hydrateRoot(rootElement, <App />);
    initializeAfterMount();
  } else {
    // Regular client-side rendering when no SSR content exists
    console.log("Performing client-side rendering");
    createRoot(rootElement).render(<App />);
    initializeAfterMount();
  }
} else {
  console.error("Root element not found");
}

// Add to the window object to make it accessible
declare global {
  interface Window {
    embedNeetoWidget?: (config: { apiKey: string }) => void;
    neetoChatInitialized?: boolean;
    fbq?: (...args: any[]) => void;
  }
}
